import React from "react";
import UpdateOutreachPage from "../../components/Pages/Outreach/Update/Update";

const UpdateOutreach = () => {
  return (
    <div>
      <UpdateOutreachPage />
    </div>
  );
};

export default UpdateOutreach;
